<ion-input
  type="text"
  [formControl]="formControl"
  [ionFormlyAttributes]="field"
></ion-input>
